var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(0 .286)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.655,
    cy: 25.253,
    fill: "#FFDCE3",
    rx: 25.345,
    ry: 25.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M9.516 30.304c.862-9.705 5.475-14.832 13.656-14.832 8.182 0 12.795 5.127 13.657 14.832h8.792c.8 0 1.448.646 1.448 1.443s-.648 1.443-1.448 1.443h-9.624a1.452 1.452 0 0 1-1.96-1.28c-.45-9.246-4-13.552-10.865-13.552-6.864 0-10.415 4.306-10.863 13.552a1.446 1.446 0 0 1-1.99 1.269c-.06.007-.12.01-.181.01h-8.69c-.8 0-1.448-.645-1.448-1.442 0-.797.648-1.443 1.448-1.443h8.068zm13.656 22.76l11.13-15.63a1.452 1.452 0 0 1 2.019-.342 1.44 1.44 0 0 1 .343 2.012l-12.31 17.288c-.578.81-1.785.81-2.363 0L9.681 39.104a1.44 1.44 0 0 1 .343-2.012 1.452 1.452 0 0 1 2.02.342l11.128 15.63zm1.166-13.939l-1.136 1.537-1.174-1.508c-2.47-3.173-3.724-5.53-3.724-7.313 0-2.728 2.366-4.958 4.89-4.921 2.501.036 4.675 2.209 4.675 4.92 0 1.765-1.19 4.118-3.53 7.285zm-3.137-7.284c0 .735.64 2.094 1.94 3.956 1.227-1.854 1.831-3.21 1.831-3.956 0-1.127-.895-2.022-1.82-2.036-.934-.013-1.951.946-1.951 2.036z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoc);
export default __webpack_public_path__ + "static/media/ic-loc.622c7365d9fca85aca29e108a7679c85.svg";
export { ForwardRef as ReactComponent };